import React from "react";
import { ConfirmModal } from "../ConfirmModal";
import { RefreshModalProps } from "./RefreshModal.types";

export const RefreshModal = ({
  open,
  isLoading = false,
  lastRefreshTime,
  onConfirm,
  onCancel,
}: RefreshModalProps) => {
  return (
    <ConfirmModal
      open={open}
      isLoading={isLoading}
      title="Refresh dataset?"
      description="Pull the latest data from your connected source. This will update underlying data, charts, and all dependent stories."
      infoText={
        lastRefreshTime ? `Last refresh: ${lastRefreshTime}` : undefined
      }
      onConfirm={onConfirm}
      onCancel={onCancel}
      confirmLabel="Refresh now"
      cancelLabel="Cancel"
      confirmVariant="primary"
    />
  );
};
